module.exports = {
  "country": "AZ",
  "artist": "Ell & Nikki",
  "song": "Running Scared",
  "year": "2011",
  "place": "1",
  "spotify": ""
};